import { ApplicationState, rootReducer } from "./store";
import { createStore, Store, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createBrowserHistory } from "history";
import keyboardServiceMiddleware from "./store/Keyboard/middleware";
import createSagaMiddleware from "redux-saga";

export const history = createBrowserHistory();

export const sagaMiddleWare = createSagaMiddleware();

export default function configureStore(): Store<ApplicationState> {
    return createStore(
        rootReducer,
        process.env.NODE_ENV === "development"
            ? composeWithDevTools(
                applyMiddleware(
                    sagaMiddleWare,
                    keyboardServiceMiddleware
                )
            )
            : applyMiddleware(
                sagaMiddleWare,
                keyboardServiceMiddleware
            )
    );
}



// WEBPACK FOOTER //
// ./src/configureStore.ts